import React from "react";
import { MainCP } from "../../../Components/paz_cuidadana/paz_cuidadana-v2/MainCP"

const ViewPazCiudadana: React.FC = () => <MainCP/>
export default ViewPazCiudadana;